/**
 * FloatingCta — Morgan Legal Group
 * Always-on floating CTAs visible on every page:
 *  - Desktop: phone + Schedule Your Consultation (right side)
 *  - Desktop: NGage live-chat bubble (left side) — script wired in index.html
 *  - Mobile: bottom bar with phone + Schedule
 */
import { useEffect, useState } from 'react';
import { Phone, Calendar } from 'lucide-react';

export default function FloatingCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Mobile floating bar — phone + Schedule */}
      <div
        className={`fixed bottom-0 left-0 right-0 z-50 lg:hidden transition-all duration-300 ${
          visible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
        }`}
      >
        <div className="bg-navy border-t-2 border-gold flex">
          <a
            href="tel:8885291315"
            className="flex-1 flex items-center justify-center gap-2 py-4 text-white font-body text-sm font-semibold border-r border-white/10 hover:bg-gold/10 transition-colors duration-200"
          >
            <Phone className="w-4 h-4 text-gold" />
            Call Now
          </a>
          <a
            href="/appointment/"
            className="flex-1 flex items-center justify-center gap-2 py-4 bg-gold text-navy font-body text-sm font-bold hover:bg-[#b8935a] transition-colors duration-200"
          >
            <Calendar className="w-4 h-4" />
            Schedule Your Consultation
          </a>
        </div>
      </div>

      {/* Desktop floating: Schedule (gold) + Phone (ghost) stacked on the right */}
      <div
        className={`fixed bottom-8 right-8 z-50 hidden lg:flex flex-col items-end gap-2 transition-all duration-300 ${
          visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
        }`}
      >
        <a
          href="/appointment/"
          className="flex items-center gap-2 bg-gold text-navy px-5 py-3 shadow-2xl font-body text-sm font-bold hover:bg-[#b8935a] transition-colors duration-200"
        >
          <Calendar className="w-4 h-4" />
          Schedule Your Consultation
        </a>
        <a
          href="tel:8885291315"
          className="flex items-center gap-2 bg-navy text-gold px-4 py-2 shadow-xl font-body text-xs font-semibold border border-gold/40 hover:bg-navy/90 transition-colors duration-200"
          aria-label="Call Morgan Legal Group"
        >
          <Phone className="w-3.5 h-3.5" />
          888-529-1315
        </a>
      </div>

      {/* MLG chat + calendar widget mounts its own FAB bottom-left via
          /public/embed.js (script tag in index.html). No React button needed. */}
    </>
  );
}
